// COHESION CONSTANTS
export const DEFAULT_FUSE_NUMBER = "8664994271";
